import React from 'react';
import PageForm from "components/pageForm";
import {Outlet} from "react-router-dom";
import SubNavbar from "components/SubNavbar/SubNavbar";
import {TabF, TabsF} from "components/tabs/tabfile";
import Button from "components/button";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";

const Invoice = () => {
    const {toggle} = useModal();
    const {language} = UseContext();

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-stretch h-full">
                        <div className="w-full flex flex-col tab:flex-row tab:justify-between gap-3">
                            <div className="flex items-center h-full">
                                <TabsF>
                                    <TabF label={"toBeSet"} tabName={'À régler'}/>
                                    <TabF label={"settle"} tabName={'Réglé'}/>
                                </TabsF>
                            </div>
                            <div className="flex flex-col tab:flex-row items-stretch tab:items-center gap-3 flex-shrink-0 tab:ml-4">
                                <Button
                                    color="PRIMARY"
                                    size="SM"
                                    onClick={() => toggle('account_statement')}
                                >
                                    {language.getValue('accountStatement.openButton', 'Relevé de compte (PDF)')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </SubNavbar>
                <div className="col-span-12">
                    <Outlet />
                </div>
            </PageForm>
        </>
    );
};

export default Invoice;
